import { render } from "solid-js/web";
import { App } from "./App";
import { creerSourceParDefaut } from "./donnees/contexte";
import { appliquerApparenceInitiale } from "./theme";
import "./styles.css";

const racine = document.getElementById("racine");
if (!racine) throw new Error("Élément #racine introuvable dans index.html.");

appliquerApparenceInitiale();
render(() => <App source={creerSourceParDefaut()} />, racine);
